import React, { useContext, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { RxCross2 } from "react-icons/rx";
import AuthContext from "../context/AuthContext";
import { isEmpty, isNumber } from "lodash";
import { apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { useContextSelector } from "use-context-selector";
import { t } from "i18next";
const StackSetting = ({ handleStackSetting }) => {
  const numberArrayCount = [1, 2, 3, 4, 5, 6, 7, 8, 9, "", 0];
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });
  const getProfileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.getProfileData;
  });
  const [focus, setFocus] = useState(0);
  const [stake, setStake] = useState(
    profileData?.stake?.slice(0, 4)?.length > 0
      ? profileData?.stake?.slice(0, 4)
      : profileData?.editStake?.slice(0, 4),
  );
  const handelDialPad = (item) => {
    if (isNumber(focus)) {
      setStake((prev) => {
        return prev?.map((res, index) => {
          if (index == focus) {
            return Number(res.toString() + item.toString());
          } else {
            return res;
          }
        });
      });
    }
  };

  const clear = () => {
    setStake((prev) => {
      return prev.map((res, index) => {
        if (index == focus && res?.toString()?.length > 0) {
          let num = Number(
            res.toString().substring(0, res.toString().length - 1),
          );
          return num;
        } else {
          return res;
        }
      });
    });
  };

  const submit = async () => {
    const { status, data: response_users } = await apiPost(
      apiPath.userProfileUpdate,
      {
        stake: stake,
      },
    );
    if (status === 200) {
      if (response_users.success) {
        getProfileData();
        handleStackSetting();
      }
    }
  };

  return (
    <div
      data-v-f50a5648
      className="s-bottom-0 s-fixed s-w-full"
      style={{ "z-index": "71", left: "0" }}
    >
      <div
        data-v-f50a5648
        className="s-bg-pop-title-bg s-flex s-flex-col s-pt-2 s-px-3px s-pb-0 s-h-full s-overscroll-y-none s-rounded-t-5px s-relative s-z-10"
      >
        <div
          data-v-f50a5648
          className="s-flex s-justify-center s-items-center s-py-2"
        >
          <span
            data-v-f50a5648
            className="s-mx-4 s-pb-2 s-text-pop-title-text s-font-bold s-text-17px"
          >
            {t("DefaultStakeSetting")}
          </span>
          <div
            onClick={() => handleStackSetting()}
            data-v-f50a5648
            className="s-icon-close s-absolute s-right-2 s-top-4 s-justify-center s-items-center s-mr-2 s-cursor-pointer s-text-global-font-default-light dark:s-text-global-font-default-dark s-text-14px"
          />
        </div>
        <div
          data-v-f50a5648
          className="s-bg-white dark:s-bg-black-900 s-rounded-t-5px s-pt-7px s-px-7px s-flex s-gap-7px"
        >
          {stake?.map((res, index) => {
            return (
              <div
                onClick={() => setFocus(index)}
                data-v-f50a5648
                className="s-w-83px s-h-40px s-flex s-items-center s-justify-center"
              >
                <span
                  data-v-f50a5648
                  name="index"
                  className={`${
                    focus == index ? "s-border-bet-focus" : ""
                  } s-text-17px s-w-full s-h-full s-flex s-justify-center s-items-center s-font-bold s-overflow-hidden s-rounded-3px s-border-solid s-text-global-font-default-light s-bg-white dark:s-bg-transparent dark:s-text-global-font-default-dark s-is-focus  s-border s-bg-white dark:s-bg-transparent`}
                >
                  {res}
                </span>
              </div>
            );
          })}
        </div>
        <div data-v-f50a5648>
          <div
            data-v-f50a5648
            className="s-grid s-grid-cols-3 s-bg-betSlip-light dark:s-bg-betSlip-dark s-pt-7px s-px-7px s-pb-0"
          >
            {numberArrayCount?.map((res) => {
              return (
                <button
                  data-v-bf7df09e
                  data-v-f50a5648
                  className="btn s-btn-normal s-relative s-text-14px s-p-3 s-font-bold s-rounded s-flex s-justify-center s-items-center disabled:s-bg-black-300 dark:disabled:s-bg-black-700 disabled:s-text-black-600 dark:disabled:s-text-black-600 disabled:s-cursor-not-allowed s-overflow-hidden a active:s-bg-opacity-10 s-calc-btn s-text-17px s-font-normal s-rounded-4px"
                  type="button"
                  onClick={() => {
                    if (isNumber(res)) {
                      if (
                        (stake
                          ?.find((res, index) => {
                            return index == focus;
                          })
                          ?.toString()?.length || 0) +
                          1 <=
                        5
                      ) {
                        handelDialPad(res);
                      }
                    }
                  }}
                >
                  <div
                    data-v-2f9c23fd
                    data-v-bf7df09e
                    className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
                    style={{ "--0b879273": "0" }}
                  >
                    <span
                      data-v-2f9c23fd
                      className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                      style={{ display: "none" }}
                    />
                    <span
                      data-v-2f9c23fd
                      className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                      style={{ display: "none" }}
                    />
                  </div>
                  {res}
                </button>
              );
            })}

            <button
              onClick={() => {
                clear();
              }}
              data-v-bf7df09e
              data-v-f50a5648
              className="btn s-btn-normal s-relative s-text-14px s-p-3 s-font-bold s-rounded s-flex s-justify-center s-items-center disabled:s-bg-black-300 dark:disabled:s-bg-black-700 disabled:s-text-black-600 dark:disabled:s-text-black-600 disabled:s-cursor-not-allowed s-overflow-hidden a active:s-bg-opacity-10 s-calc-btn s-icon-backspace s-text-24px"
              type="button"
            >
              <div
                data-v-2f9c23fd
                data-v-bf7df09e
                className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
                style={{ "--0b879273": "0" }}
              >
                <span
                  data-v-2f9c23fd
                  className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                  style={{ display: "none" }}
                />
                <span
                  data-v-2f9c23fd
                  className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                  style={{ display: "none" }}
                />
              </div>
            </button>
          </div>
        </div>
        <div
          data-v-f50a5648
          className="s-bg-betSlip-light dark:s-bg-betSlip-dark s-px-2"
        >
          <button
            onClick={() => {
              submit();
            }}
            data-v-bf7df09e
            data-v-f50a5648
            className="btn s-btn-normal s-relative s-text-14px s-p-3 s-font-bold s-rounded s-flex s-justify-center s-items-center disabled:s-bg-black-300 dark:disabled:s-bg-black-700 disabled:s-text-black-600 dark:disabled:s-text-black-600 disabled:s-cursor-not-allowed s-overflow-hidden a active:s-bg-opacity-10 s-w-full s-h-40px s-my-2 s-text-17px"
            type="submit"
          >
            <div
              data-v-2f9c23fd
              data-v-bf7df09e
              className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
              style={{ "--0b879273": "0" }}
            >
              <span
                data-v-2f9c23fd
                className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                style={{ display: "none" }}
              />
              <span
                data-v-2f9c23fd
                className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                style={{ display: "none" }}
              />
            </div>
            {t("Submit")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StackSetting;
